// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MOHKwpMhPOs6EhP110lD{margin-top:24px}.Lo4UOhja1HsGNtLzq1Jq{background:var(--white-100);z-index:var(--zIndex-BASE_10);margin-top:32px;padding-bottom:24px;position:-webkit-sticky;position:sticky;bottom:0}.TqCaAAK6kIs6cVp35tE1{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `MOHKwpMhPOs6EhP110lD`,
	"actions": `Lo4UOhja1HsGNtLzq1Jq`,
	"btn": `TqCaAAK6kIs6cVp35tE1`
};
export default ___CSS_LOADER_EXPORT___;
